module.exports = __webpack_public_path__ + "img/arrow_back_ios.6ed46d8c.svg";